import { render, staticRenderFns } from "./discordTalkroom.vue?vue&type=template&id=6246ec5e&scoped=true"
import script from "./discordTalkroom.vue?vue&type=script&lang=js"
export * from "./discordTalkroom.vue?vue&type=script&lang=js"
import style0 from "./discordTalkroom.vue?vue&type=style&index=0&id=6246ec5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6246ec5e",
  null
  
)

export default component.exports